"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const date_fns_1 = require("date-fns");
const _1 = require(".");
class InvoiceSummary {
    constructor(partnerId, date, billingPeriod, currency, grossPremium, serviceFee, tax, commission, totalCreditCard, netAmountDue, version) {
        this.date = date;
        this.billingPeriod = billingPeriod;
        this.currency = currency;
        this.grossPremium = grossPremium;
        this.serviceFee = serviceFee;
        this.tax = tax;
        this.commission = commission;
        this.totalCreditCard = totalCreditCard;
        this.netAmountDue = netAmountDue;
        this.version = version;
        const invoiceId = _1.generateInvoiceId(billingPeriod);
        this.invoiceNumber = `${partnerId}.${invoiceId}`;
    }
    get invoiceId() {
        return date_fns_1.format(date_fns_1.parseISO(this.billingPeriod.startDate), "yyyy'M'MM");
    }
}
exports.default = InvoiceSummary;
//# sourceMappingURL=invoiceSummary.class.js.map